<nb-card class="dialog" [nbSpinner]="loading">
  <!-- <nb-card class="dialog"> -->
  <nb-card-header class="header">
    <div class="right-side">
      <P class="title" data-testid="preview-title">
        <ng-container *ngIf="type === 'ReplacementExcelWithSql'; else fileName">
          {{ oldDataSourceName }}
        </ng-container>
        <ng-template #fileName>{{previewDataSourceInfo?.fileName}}</ng-template>
      </P>
    </div>
    <div class="left-side">
      <p class="text">ردیف</p>
      <button class="button" [ngClass]="{'active' : rowNumber === hundred}" (click)="loadTableContent(hundred)">
        100
      </button>
      <button class="button" [ngClass]="{'active' : rowNumber === twoHundred}" (click)="loadTableContent(twoHundred)">
        200
      </button>
      <button class="button" [ngClass]="{'active' : rowNumber === thousand}" (click)="loadTableContent(thousand)">
        1000
      </button>
      <morva-icons class="icon" icon="changeDataType"></morva-icons>
      <p data-testid="change-data-type" class="text" [matMenuTriggerFor]="dataType" #menuTrigger="matMenuTrigger" (menuOpened)="openMenuDataType()">تغییر نوع داده</p>
    </div>
  </nb-card-header>
  <mat-menu #dataType="matMenu" class="change-type">
    <input
      #searchType
      nbInput
      type="search"
      class="search-input"
      placeholder="جستجو"
      (input)="searchInColumnsTypes(searchType.value)"
      (click)="$event.stopPropagation()"
    />
    <div class="options">
      <div
        class="options-row"
        *ngFor="let column of showColumnsTypes | keyvalue"
        (click)="$event.stopPropagation()"
      >
        <p class="limit-text" [nbTooltipTrigger]="column.key?.length > 10 ? 'hover' : 'noop'" [nbTooltip]="column.key">{{ column.key }}</p>
        <ng-select
          #search
          appendTo="body"
          class="data-type-preview-select"
          bindLabel="type"
          bindValue="type"
          [items]="types"
          [searchable]="false"
          [ngModel]="column.value"
          (ngModelChange)="setColumnType($event, column.key)"
        >
        </ng-select>
      </div>
    </div>
    <button class="save-btn" nbButton (click)="saveChangedColumnsType()">ذخیره</button>
  </mat-menu>
  <nb-card-body class="body">
    <div class="table-container d-flex flex-column" data-testid="table-container">
      <table *ngIf="columns && !hasError">
        <tr>
          <th *ngFor="let column of columns.data | keyvalue">
            {{ column.key }}
          </th>
        </tr>
        <tr *ngFor="let row of columnsDataLength">
          <td *ngFor="let column of columns.data | keyvalue" [innerHTML]="column.value.columnData[row]|toImage:column.value.columnData[row]"></td>
        </tr>
      </table>

      <div class="d-flex flex-column my-auto justify-content-center align-items-center" *ngIf="hasError && !loading">
        <img data-testid="table-error-img" class="table-error" src="assets/images/excel-error.png" alt="excel-error">
        <p data-testid="table-error-p" class="table-error">داده‌ی موجود در صفحه موردنظر قابل‌خواندن نیست.</p>
        <small data-testid="excel-error" class="excel-error">لطفا از وجود داده‌ و صحت آن در صفحه موردنظر اطمینان حاصل کنید.</small>
      </div>

      <div class="d-flex flex-column my-auto justify-content-center align-items-center" *ngIf="isEmptySheet && !hasError">
        <img data-testid="table-error-img" class="table-error" src="assets/images/excel-empty.png" alt="excel-error">
        <p data-testid="table-error-p" class="table-error">داده‌ای برای نمایش وجود ندارد.</p>
        <small data-testid="excel-error" class="excel-error">جدول باید حاوی حداقل یک مقدار باشد.</small>
      </div>
    </div>

    <div class="error-container mt-2" *ngIf="columns?.columnWarnings?.length > 0 && (type === 'ReplacementDataSource' || type === 'ReplacementExcelWithSql')">
      <div class="px-3 py-1" *ngFor="let warning of columns.columnWarnings">
        <morva-linear-notifiction [message]="warning" messageType="error"></morva-linear-notifiction>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer class="footer">
    <button (click)="deletePreviewConnection()">خروج</button>
    <button (click)="save()" [disabled]="isUploading || hasError || isEmptySheet" [nbSpinner]="isUploading">بارگذاری</button>
  </nb-card-footer>
</nb-card>
